import axios from "axios";

// constants
import { BASE_URL } from "src/utils/constants";

export const resetPassword = (_password, _code) => {
  const data = {
    VerificationCode: _code,
    Password: _password,
  };

  const response = axios({
    method: "post",
    url: `${BASE_URL()}/ResetPassword`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  });

  return response;
};
